import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { TaskForAsyncTaskFunction } from 'ember-concurrency';
import type {
  Currency,
  CurrencyConversionExchangeRatesProfile,
} from 'lumen/models';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';
import protectedRoute from 'lumen/utils/decorators/protected-route';

export type CurrencyConversionIndexModel = {
  baseCurrencies: TaskForAsyncTaskFunction<
    { restartable: boolean },
    () => Promise<Currency[]>
  >;
  exchangeRatesProfiles: TaskForAsyncTaskFunction<
    { restartable: boolean },
    () => Promise<CurrencyConversionExchangeRatesProfile[]>
  >;
};

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  featureToggles: FEATURE_TOGGLES.CENTRAL_CURRENCY_CONVERSION,
  features: ['settings.exchange_rate_profiles.view'],
  redirectTo: 'market.settings',
})
export default class MarketSettingsCurrencyConversionIndexRoute extends Route {
  @service declare currencyConversion: Services['currency-conversion'];

  model(): CurrencyConversionIndexModel {
    const model: CurrencyConversionIndexModel = {
      baseCurrencies: this.currencyConversion.getBaseCurrenciesTask,
      exchangeRatesProfiles:
        this.currencyConversion.getExchangeRatesProfilesTask,
    };

    void model.exchangeRatesProfiles.perform();

    return model;
  }
}
